// @flow
import { Label as BaseFieldLabel } from 'mz-ui-kit/core/BaseField/appearance/material'

// Constants
export const SIZES = {
  normal: {
    width: 46,
    height: 18,
    handleDiameter: 20,
  },
}

export const Container = () => ({
  display: 'flex',
  flexDirection: 'column',
  fontSize: '14px',
})

export const Switch = ({ $disabled, $size }: any) => ({
  position: 'relative',
  display: 'flex',
  alignSelf: 'flex-start',
  opacity: $disabled ? 0.5 : 1,
  borderRadius: `${SIZES[$size].height / 2}px`,
  WebkitTransition: 'opacity 0.25s',
  MozTransition: 'opacity 0.25s',
  transition: 'opacity 0.25s',
  touchAction: 'none',
  WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
  userSelect: 'none',
})

export const Background = ({
  $backgroundColor,
  $disabled,
  $isDragging,
  $size,
}: any) => ({
  height: `${SIZES[$size].height}px`,
  width: `${SIZES[$size].width}px`,
  margin: `${Math.max(
    0,
    (SIZES[$size].handleDiameter - SIZES[$size].height) / 2
  )}px`,
  background: $backgroundColor,
  borderRadius: `${SIZES[$size].height / 2}px`,
  cursor: $disabled ? 'default' : 'pointer',
  transition: $isDragging ? null : 'background 0.25s',
})

export const Label = ({ $palette }: any) => ({
  ...BaseFieldLabel(({ $palette, $focus: true }: any)),
  display: 'block',
  position: 'initial',
  paddingBottom: '6px',
  flexDirection: 'column',
  color: $palette('PRIMARY').toString(),
  transform: 'scale(1) translate3d(0px, 0px, 0px)',
})

export const Toggler = ({
  $togglerColor,
  $disabled,
  $pos,
  $isDragging,
  $hasOutline,
  $size,
}: any) => ({
  height: `${SIZES[$size].handleDiameter}px`,
  width: `${SIZES[$size].handleDiameter}px`,
  background: $togglerColor,
  cursor: $disabled ? 'default' : 'pointer',
  borderRadius: '50%',
  position: 'absolute',
  transform: `translateX(${$pos}px)`,
  left: `${Math.max(
    0,
    (SIZES[$size].height - SIZES[$size].handleDiameter) / 2
  )}px`,
  outline: 0,
  boxShadow: $hasOutline
    ? '0px 0px 1px 10px rgba(0, 0, 0, 0.2)'
    : '0px 1px 5px rgba(0, 0, 0, 0.6)',
  border: 0,
  transition: $isDragging
    ? null
    : 'background-color 0.25s, transform 0.25s, box-shadow 0.15s',
})

export const ValueText = ({ $palette }: any) => ({
  marginLeft: '10px',
  color: `${$palette('TEXT').lighten(14)}`,
  fontWeight: 'bold',
  alignSelf: 'center',
})
